<template>

  <div id="prv-sizing-tool">
    <input type="hidden" name="hysteresis" id="hysteresisname" :value="$gettext('Hysteresekurve')">
    <input type="hidden" name="Vibration" id="vibration" :value="$gettext('Vibration')">
    <input type="hidden" name="Optimum" id="optimum" :value="$gettext('Optimum')">

    <input type="hidden" name="EmailValveBody" id="emailValveBody"
           :value="$gettext('Diese%20Information%20koennte%20interessieren%0d%0a')">
    <input type="hidden" name="EmailValveSubject" id="emailValveSubject"
           :value="$gettext('Georg%20Fischer%20Piping%20Systems%20Valve%20Sizing%20Tool')">
    <div id="toolInputs">
      <div class="halfRow">
        <h2><translate>Valve Information</translate></h2>
        <div class="myblock">
          <div class="myLabel">
            <span><translate>Valve Type</translate></span>
            <span class="infoI hidePrint" id="tooltipValve" v-tooltip.right="{ ref: 'refTooltipValve' }">&nbsp;</span>
          </div>
          <div class="row ">
            <Multiselect class="valve" ref="selectvalve" @changeSelect="globalreInit"></Multiselect>
<!--            <div class="selectWrapper">-->
<!--              <select class="valve">-->
<!--                <option value="dhv">Druckhalteventil 586</option>-->
<!--                <option value="drv">Druckreduzierventil 582</option>-->
<!--              </select>-->

<!--            </div>-->
            <div ref="refTooltipValve" class="tooltip-content">
<!--              <translate>Reduzierventil Typ 582: Reduziert einen höheren Eingangsdruck auf einen definierten, konstanten-->
<!--                Abgangsdruck. Halteventil Typ 586: Bewahrt einen konstanten Eingangsdruck bei schwankendem-->
<!--                Systemdruck.</translate>-->
              <translate>TooltipValve</translate>
            </div>
          </div>
        </div>

        <div class="myblock">
          <div class="myLabel">
            <span><translate>Pipe Dimension</translate></span>
            <span class="infoI hidePrint" id="tooltipPipeDimension" v-tooltip.right="{ ref: 'refTooltipPipe' }">&nbsp;</span>
          </div>
          <div class="row ">
            <Multiselect ref="selectdiamter" @changeSelect="globalonChangeDiameter"></Multiselect>
<!--            <div class="selectWrapper">-->
<!--              <select class="variant2 diameter">-->
<!--                <option value="10">16DN10 (3/8")</option>-->
<!--                <option value="15">20DN15 (1/2")</option>-->
<!--                <option value="20">25DN20 (3/4")</option>-->
<!--                <option value="25">32DN25 (1")</option>-->
<!--                <option value="32">40DN32 (1 ¼")</option>-->
<!--                <option value="40">50DN40 (1 ½")</option>-->
<!--                <option value="50">63DN50 (2")</option>-->
<!--              </select>-->

<!--            </div>-->
            <div ref="refTooltipPipe" class="tooltip-content">
<!--              <translate>Selektieren Sie die Dimension, welche Sie ohne Reduzierungen verwenden würden, um ein Ventil-->
<!--                einzubinden.</translate>-->
              <translate>TooltipPipe</translate>
            </div>
          </div>
        </div>

        <div class="myblock">
          <div class="myLabel">
            <span><translate>Pressure Range</translate></span>
            <span class="infoI hidePrint" id="tooltipPressureRange" v-tooltip.right="{ ref: 'refTooltipPressureRange' }">&nbsp;</span>
          </div>
          <div class="row ">
            <Multiselect ref="selectpressure_range" @changeSelect="globalreInit"></Multiselect>
<!--            <div class="selectWrapper">-->
<!--              <select class="variant2 pressure_range">-->
<!--                <option value="variant2">0.5 - 9 bar</option>-->
<!--                <option value="variant1">0.3 - 3 bar</option>-->
<!--              </select>-->

<!--            </div>-->
            <div ref="refTooltipPressureRange" class="tooltip-content">
<!--              <translate>Standard Einstellbereich ist 0.5 - 9 bar (7-130 psi). Für eine bessere Genauigkeit in kleineren-->
<!--                Druckbereichen wählen Sie 0.3 - 3 bar (4-44 psi), es wird den maximal zulässigen Durchfluss-->
<!--                reduzieren.</translate>-->
              <translate>TooltipPressure</translate>
            </div>
          </div>
        </div>

        <div class="myblock">
          <div class="myLabel">
            <span><translate>Units</translate></span>
            <span class="infoI hidePrint" id="tooltipUnits" v-tooltip.right="{ ref: 'refTooltipUnits' }">&nbsp;</span>
          </div>
          <div class="row ">
            <Multiselect ref="selectunitChange" @changeSelect="globalonChangeUnit"></Multiselect>

<!--            <div class="selectWrapper">-->
<!--              <select class="variant2" id="unitChange">-->
<!--                <option value="metric">Metrisch</option>-->
<!--                <option value="us">Imperial</option>-->
<!--              </select>-->

<!--            </div>-->
            <div ref="refTooltipUnits" class="tooltip-content">
              <translate>Wählen Sie zwischen metrischem oder zölligem System.</translate>
            </div>
          </div>
        </div>


      </div>

      <div class="halfRow performancedata">
        <h2><translate>Performance Data</translate></h2>
        <div class="myblock" id="blockInletPressure">
          <div class="myLabel">
            <span><translate>Inletpressure P1</translate> (<span class="unit_1">bar</span>)</span>
            <span class="infoI hidePrint" id="tooltipInlet" v-tooltip.right="{ ref: 'refTooltipInlet' }">&nbsp;</span>
          </div>
          <div class="row ">
            <div class="inputWrapper">
              <input type="number" value="2" class="variant2" id="inletPressure">
            </div>
            <div ref="refTooltipInlet" class="tooltip-content">
<!--              <translate>Tragen Sie hier den gewünschten Einstelldruck ein. Je nach Ventiltyp P1 oder P2. Soll das-->
<!--                Duckhalteventil bei einem bestimmten Druck öffnen tragen Sie hier den Öffnungsdruck ein und beim-->
<!--                Durchfluss 0.</translate>-->
              <translate>TooltipInlet</translate>
            </div>
          </div>
        </div>

        <div class="myblock" id="blockOutletPressure">
          <div class="myLabel">
            <span><translate>Outletpressure P2</translate> (<span class="unit_1">bar</span>)</span>
            <span class="infoI hidePrint" id="tooltipOutlet" v-tooltip.right="{ ref: 'refTooltipOutlet' }">&nbsp;</span>
          </div>
          <div class="row ">
            <div class="inputWrapper">
            <input type="number" value="2" class="variant2" id="outletPressure">
            </div>
            <div ref="refTooltipOutlet" class="tooltip-content">
<!--              <translate>Tragen Sie hier den gewünschten Einstelldruck ein. Je nach Ventiltyp P1 oder P2. Soll das-->
<!--                Duckhalteventil bei einem bestimmten Druck öffnen tragen Sie hier den Öffnungsdruck ein und beim-->
<!--                Durchfluss 0.</translate>-->
              <translate>TooltipOutlet</translate>
            </div>
          </div>
        </div>

        <div class="myblock">
          <div class="myLabel">
            <span><translate>Flow Q</translate> (<span class="unit_2">l/h</span>)</span>
            <span class="infoI hidePrint" id="tooltipFlow" v-tooltip.right="{ ref: 'refTooltipFlow' }">&nbsp;</span>
          </div>
          <div class="row ">
            <div class="inputWrapper">
            <input pattern="[0-9.,]+" type="number" value="500" class="variant2" id="flowrate">
            </div>
            <div ref="refTooltipFlow" class="tooltip-content">
<!--              <translate>Tragen Sie hier bitte den Durchfluss ein, welcher sich beim gewünschten Druck einstellen wird.-->
<!--                Durchflussschwankungen führen zur Verschiebung des Arbeitspunktes auf der Hysterese-Kurve und können-->
<!--                somit zu Schwankungen des eingestellten Druckes führen.</translate>-->
              <translate>TooltipFlow</translate>
            </div>
          </div>
        </div>

      </div>
      <div class="halfRow" style="margin-right: 0;">
        <div class="imageWrapper">
          <span class="helper"></span>
          <img src="../assets/1503050813477.png" id="productImg" style="max-width:420px; vertical-align: middle;width:100%">
          <img src="../assets/1503050813484.png" id="productImg2" style="max-width:420px; vertical-align: middle;width:100%; ">
        </div>
      </div>

      <br class="clearfix"/><br>
      <div class="arrow hidePrint" style="margin-left: -6px;">
        <span id="doPrint" class="bImage" v-on:click="preparePrint"><translate>Print</translate></span>
      </div>
      <div class="arrow hidePrint" style="margin-left: -6px;">
        <span id="sendEmail" class="bImage" v-on:click="sendMail"><translate>E-Mail</translate></span>
      </div>
      <br class="clearfix"/>
    </div>

    <div id="vc" class="clearfix">
      <div class="images" style="display: none">
        <div class="image landscape"><img src="../assets/1503050813477.png" alt="gfps_tool_DHV_icons"
                                          title="gfps_tool_DHV_icons" class="cq-dd-image img dhv"
                                          style="display: inline;"></div>
        <div class="image landscape"><img src="../assets/1503050813484.png" alt="gfps_tool_DRV_icons"
                                          title="gfps_tool_DRV_icons" class="cq-dd-image img drv"
                                          style="display: none;"></div>
      </div>
      <div class="inputz clearfix">
        <form novalidate="novalidate">
          <div class="right">
            <div id="canvas" style="position: relative;" class="jqplot-target">
              <canvas width="773" height="250" style="position: absolute; left: 0px; top: 0px;"
                      class="jqplot-base-canvas"></canvas>
              <div class="jqplot-title"
                   style="position: absolute; top: 0px; left: 0px; width: 773px; text-align: center;"><translate>Hysteresekurve
                16DN10 (3/8")</translate>
              </div>
              <div class="jqplot-axis jqplot-xaxis"
                   style="position: absolute; width: 773px; height: 40px; left: 0px; bottom: 0px;">
                <canvas width="19" height="16" style="position: absolute; left: 387.5px; bottom: 0px;"
                        class="jqplot-xaxis-label"></canvas>
                <div class="jqplot-xaxis-tick" style="position: absolute; left: 27.5px;">0</div>
                <div class="jqplot-xaxis-tick" style="position: absolute; left: 94.2px;">100</div>
                <div class="jqplot-xaxis-tick" style="position: absolute; left: 167.4px;">200</div>
                <div class="jqplot-xaxis-tick" style="position: absolute; left: 240.6px;">300</div>
                <div class="jqplot-xaxis-tick" style="position: absolute; left: 313.8px;">400</div>
                <div class="jqplot-xaxis-tick" style="position: absolute; left: 387px;">500</div>
                <div class="jqplot-xaxis-tick" style="position: absolute; left: 460.2px;">600</div>
                <div class="jqplot-xaxis-tick" style="position: absolute; left: 533.4px;">700</div>
                <div class="jqplot-xaxis-tick" style="position: absolute; left: 606.6px;">800</div>
                <div class="jqplot-xaxis-tick" style="position: absolute; left: 679.8px;">900</div>
                <div class="jqplot-xaxis-tick" style="position: absolute; left: 749.5px;">1000</div>
              </div>
              <div class="jqplot-axis jqplot-yaxis"
                   style="position: absolute; height: 250px; width: 31px; left: 0px; top: 0px;">
                <canvas width="16" height="22" style="position: absolute; top: 109.25px; left: 0px;"
                        class="jqplot-yaxis-label"></canvas>
                <div class="jqplot-yaxis-tick" style="position: absolute; top: 201px;">0</div>
                <div class="jqplot-yaxis-tick" style="position: absolute; top: 183.05px;">1</div>
                <div class="jqplot-yaxis-tick" style="position: absolute; top: 165.1px;">2</div>
                <div class="jqplot-yaxis-tick" style="position: absolute; top: 147.15px;">3</div>
                <div class="jqplot-yaxis-tick" style="position: absolute; top: 129.2px;">4</div>
                <div class="jqplot-yaxis-tick" style="position: absolute; top: 111.25px;">5</div>
                <div class="jqplot-yaxis-tick" style="position: absolute; top: 93.3px;">6</div>
                <div class="jqplot-yaxis-tick" style="position: absolute; top: 75.35px;">7</div>
                <div class="jqplot-yaxis-tick" style="position: absolute; top: 57.4px;">8</div>
                <div class="jqplot-yaxis-tick" style="position: absolute; top: 39.45px;">9</div>
                <div class="jqplot-yaxis-tick" style="position: absolute; top: 21.5px;">10</div>
              </div>
              <canvas width="773" height="250" class="jqplot-grid-canvas"
                      style="position: absolute; left: 0px; top: 0px;"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px;"
                      class="jqplot-series-shadowCanvas"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px;"
                      class="jqplot-series-shadowCanvas"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px;"
                      class="jqplot-series-shadowCanvas"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px;"
                      class="jqplot-series-shadowCanvas"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px;"
                      class="jqplot-series-shadowCanvas"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px; z-index: 1;"
                      class="jqplot-series-canvas"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px; z-index: 1;"
                      class="jqplot-series-canvas"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px; z-index: 1;"
                      class="jqplot-series-canvas"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px; z-index: 1;"
                      class="jqplot-series-canvas"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px; z-index: 1;"
                      class="jqplot-series-canvas"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px;"
                      class="jqplot-highlight-canvas"></canvas>
              <div class="jqplot-highlighter-tooltip" style="position: absolute; display: none; z-index: 2;"></div>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px; z-index: 0;"
                      class="jqplot-overlayCanvas-canvas"></canvas>
              <div class="jqplot-canvasOverlay-tooltip" style="position: absolute; display: none;"></div>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px;"
                      class="jqplot-lineRenderer-highlight-canvas"></canvas>
              <canvas width="732" height="179" style="position: absolute; left: 31px; top: 30.5px; z-index: 5;"
                      class="jqplot-event-canvas"></canvas>
            </div>
            <div class="center" style="display: none">
              <div class="clearfix">
                <h3><translate>Ventildimension</translate></h3>
                <div class="row clearfix">
                  <span id="minPressure"><translate>16DN10 (3/8")</translate></span>
                  <div id="rangePressure"
                       class="ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all"
                       aria-disabled="false"><a class="ui-slider-handle ui-state-default ui-corner-all" href="#"
                                                style="left: 0%;"></a></div>
                  <span id="maxPressure"><translate>63DN50 (2")</translate></span>
                </div>
                <div class="row clearfix short">
                  <label>Ventildaten</label>
                  <select class="variant2" id="ventilData">
                    <option value="10"><translate>16DN10 (3/8")</translate></option>
                    <option value="15"><translate>20DN15 (1/2")</translate></option>
                    <option value="20"><translate>25DN20 (3/4")</translate></option>
                    <option value="25"><translate>32DN25 (1")</translate></option>
                    <option value="32"><translate>40DN32 (1 ¼")</translate></option>
                    <option value="40"><translate>50DN40 (1 ½")</translate></option>
                    <option value="50"><translate>63DN50 (2")</translate></option>
                  </select>
                  <div class="tooltip">
                    <div class="inner">
                      <translate>Wählen Sie die gewünschte Ventildimension. Sollte der Arbeitspunkt im orangen Bereich liegen,
                      können Sie kleinere Ventildimensionen ausprobieren. Kleinere Ventildimensionen bewegen den
                        Arbeitspunkt nach rechts, grössere nach links.</translate><span class="close"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <div class="row clearfix">
<!--                <a class="link left" title="E-Mail Link einem Freund senden"-->
<!--                                     href="mailto:?subject=Georg%20Fischer%20Piping%20Systems%20Valve%20Sizing%20Tool&amp;body=Diese%20Information%20koennte%20interessieren%0d%0ahttps://www.gfps.com/country_DE/de/support_and_services/online_tools/valve_sizing_tool.lightbox.html%3Fpressure_range=variant2%26ventilData=dhv%26pressure=2%26flow=500%26inputsDimension=10%26unit=metric"-->
<!--                                     id="linkValve">E-Mail</a>-->
              </div>


            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
var $;
/* eslint-disable */
var unit1_de = "bar"
    , unit2_de = "l/h"
    , unit1_en = "psi"
    , unit2_en = "gpm"
    , ventilDaten = [];
window.reInit = function (){};
window.onChangeDiameter = function (){};
window.onChangeUnit  = function (){};
function getURLParameter(sParam){
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++)
  {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam)
    {
      return sParameterName[1];
    }
  }
}
var loadScript = function (src, callback)
{
  var s,
      r,
      t;
  r = false;
  s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = src;
  s.onload = s.onreadystatechange = function() {
    if ( !r && (!this.readyState || this.readyState == 'complete') )
    {
      r = true;
      callback();
    }
  };
  t = document.getElementsByTagName('script')[0];
  t.parentNode.insertBefore(s, t);
};
// eslint-disable-next-line no-unused-vars

// import $ from 'jquery'
import Multiselect from "@/components/multi_select";
import { useGettext } from "@jshmrtn/vue3-gettext";
import classList from "@/assets/classList.min.js";
let $gettext;

export default {
  name: "PrvSizing",
  components: {Multiselect},
  props: ['myvm'],
  setup: function () {
    $gettext = useGettext().$gettext;
    window.$gettext = useGettext();
    const language = useGettext();
    return {
      language,
    };
  },
  mounted: function () {
    this.$nextTick(() => {

    })

  },
  beforeCreate: function () {
    this.$nextTick(function () {
      console.log("version", "20231013_TEST2");

      unit1_de = $gettext("bar");
      unit2_de = $gettext("l/h");
      unit1_en = $gettext("psi");
      unit2_en = $gettext("gpm");
      ventilDaten = [
        {
          id: "drv_10_variant2",
          name: "Druckreduzierventil DN10 Beide Federn",
          hystereseMin: 0.4,
          hysterese: 0.5,
          qMax: 1000,
          qFlex: 1000,
          steigung: 1500,
          steigungMin: 1500,
          durchflussanpassung: 1.8,
          steigungFlex: 750,
        },
        {
          id: "drv_15_variant2",
          name: "Druckreduzierventil DN15 Beide Federn",
          hystereseMin: 0.4,
          hysterese: 0.5,
          qMax: 1600,
          qFlex: 1600,
          steigung: 2200,
          steigungMin: 2200,
          durchflussanpassung: 2,
          steigungFlex: 1000,
        },
        {
          id: "drv_20_variant2",
          name: "Druckreduzierventil DN20 Beide Federn",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 2500,
          qFlex: 2500,
          steigung: 3500,
          steigungMin: 3500,
          durchflussanpassung: 1.25,
          steigungFlex: 2500,
        },
        {
          id: "drv_25_variant2",
          name: "Druckreduzierventil DN25 Beide Federn",
          hystereseMin: 0.35,
          hysterese: 0.4,
          qMax: 4100,
          qFlex: 4100,
          steigung: 5200,
          steigungMin: 5200,
          durchflussanpassung: 1.15,
          steigungFlex: 0,
        },
        {
          id: "drv_32_variant2",
          name: "Druckreduzierventil DN32 Beide Federn",
          hystereseMin: 0.3,
          hysterese: 0.3,
          qMax: 6500,
          qFlex: 6500,
          steigung: 8000,
          steigungMin: 8000,
          durchflussanpassung: 1.45,
          steigungFlex: 5500,
        },
        {
          id: "drv_40_variant2",
          name: "Druckreduzierventil DN40 Beide Federn",
          hystereseMin: 0.3,
          hysterese: 0.3,
          qMax: 10700,
          qFlex: 10700,
          steigung: 8800,
          steigungMin: 8800,
          durchflussanpassung: 1.45,
          steigungFlex: 0,
        },
        {
          id: "drv_50_variant2",
          name: "Druckreduzierventil DN50 Beide Federn",
          hystereseMin: 0.3,
          hysterese: 0.3,
          qMax: 16200,
          qFlex: 16200,
          steigung: 10500,
          steigungMin: 10500,
          durchflussanpassung: 2.1,
          steigungFlex: 0,
        },


        {
          id: "drv_10_variant1",
          name: "Druckreduzierventil DN10 Innere Feder",
          hystereseMin: 0.3,
          hysterese: 0.4,
          qMax: 1000,
          qFlex: 1000,
          steigung: 2000,
          steigungMin: 2000,
          durchflussanpassung: 1.1,
          steigungFlex: 1100,
        },
        {
          id: "drv_15_variant1",
          name: "Druckreduzierventil DN15 Innere Feder",
          hystereseMin: 0.3,
          hysterese: 0.4,
          qMax: 1600,
          qFlex: 1600,
          steigung: 3000,
          steigungMin: 3000,
          durchflussanpassung: 1.45,
          steigungFlex: 1500,
        },
        {
          id: "drv_20_variant1",
          name: "Druckreduzierventil DN20 Innere Feder",
          hystereseMin: 0.3,
          hysterese: 0.4,
          qMax: 2500,
          qFlex: 2500,
          steigung: 6000,
          steigungMin: 4000,
          durchflussanpassung: 0.6,
          steigungFlex: 0,
        },
        {
          id: "drv_25_variant1",
          name: "Druckreduzierventil DN25 Innere Feder",
          hystereseMin: 0.3,
          hysterese: 0.3,
          qMax: 4100,
          qFlex: 4100,
          steigung: 6800,
          steigungMin: 6800,
          durchflussanpassung: 0.6,
          steigungFlex: 0,
        },
        {
          id: "drv_32_variant1",
          name: "Druckreduzierventil DN32 Innere Feder",
          hystereseMin: 0.2,
          hysterese: 0.3,
          qMax: 6500,
          qFlex: 6500,
          steigung: 16000,
          steigungMin: 16000,
          durchflussanpassung: 0.6,
          steigungFlex: 0,
        },
        {
          id: "drv_40_variant1",
          name: "Druckreduzierventil DN40 Innere Feder",
          hystereseMin: 0.2,
          hysterese: 0.3,
          qMax: 10700,
          qFlex: 10700,
          steigung: 22000,
          steigungMin: 22000,
          durchflussanpassung: 0.95,
          steigungFlex: 0,
        },
        {
          id: "drv_50_variant1",
          name: "Druckreduzierventil DN50 Innere Feder",
          hystereseMin: 0.2,
          hysterese: 0.3,
          qMax: 16200,
          qFlex: 16200,
          steigung: 15000,
          steigungMin: 15000,
          durchflussanpassung: 1.4,
          steigungFlex: 0,
        },
        {
          id: "dhv_10_variant2",
          name: "Druckhalteventil DN10 Beide Federn",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 1000,
          qFlex: 1000,
          steigung: 2000,
          steigungMin: 2000,
          durchflussanpassung: 0,
          steigungFlex: 0,
        },
        {
          id: "dhv_15_variant2",
          name: "Druckhalteventil DN15 Beide Federn",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 1600,
          qFlex: 1600,
          steigung: 1200,
          steigungMin: 1200,
          durchflussanpassung: 0,
          steigungFlex: 0,
        },
        {
          id: "dhv_20_variant2",
          name: "Druckhalteventil DN20 Beide Federn",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 2500,
          qFlex: 2500,
          steigung: 2600,
          steigungMin: 2600,
          durchflussanpassung: 0,
          steigungFlex: 0,
        },
        {
          id: "dhv_25_variant2",
          name: "Druckhalteventil DN25 Beide Federn",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 4100,
          qFlex: 4100,
          steigung: 2750,
          steigungMin: 2750,
          durchflussanpassung: 0,
          steigungFlex: 0,
        }, {
          id: "dhv_32_variant2",
          name: "Druckhalteventil DN32 Beide Federn",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 6500,
          qFlex: 6500,
          steigung: 5800,
          steigungMin: 5800,
          durchflussanpassung: 0,
          steigungFlex: 0,
        },
        {
          id: "dhv_40_variant2",
          name: "Druckhalteventil DN40 Beide Federn",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 10700,
          qFlex: 10700,
          steigung: 5500,
          steigungMin: 5500,
          durchflussanpassung: 0,
          steigungFlex: 0,
        },
        {
          id: "dhv_50_variant2",
          name: "Druckhalteventil DN50 Beide Federn",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 16200,
          qFlex: 16200,
          steigung: 6300,
          steigungMin: 6300,
          durchflussanpassung: 0,
          steigungFlex: 0,
        },
        {
          id: "dhv_10_variant1",
          name: "Druckhalteventil DN10 Innere Feder",
          hystereseMin: 0.3,
          hysterese: 0.4,
          qMax: 1000,
          qFlex: 1000,
          steigung: 5000,
          steigungMin: 5000,
          durchflussanpassung: 0,
          steigungFlex: 0,
        },
        {
          id: "dhv_15_variant1",
          name: "Druckhalteventil DN15 Innere Feder",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 1600,
          qFlex: 1600,
          steigung: 2000,
          steigungMin: 2000,
          durchflussanpassung: 0,
          steigungFlex: 0,
        }
        ,
        {
          id: "dhv_20_variant1",
          name: "Druckhalteventil DN20 Innere Feder",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 2500,
          qFlex: 2500,
          steigung: 4200,
          steigungMin: 4200,
          durchflussanpassung: 0,
          steigungFlex: 0,
        }
        ,
        {
          id: "dhv_25_variant1",
          name: "Druckhalteventil DN25 Innere Feder",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 4100,
          qFlex: 4100,
          steigung: 4100,
          steigungMin: 4100,
          durchflussanpassung: 0,
          steigungFlex: 0,
        }
        ,
        {
          id: "dhv_32_variant1",
          name: "Druckhalteventil DN32 Innere Feder",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 6500,
          qFlex: 6500,
          steigung: 10500,
          steigungMin: 10500,
          durchflussanpassung: 0,
          steigungFlex: 0,
        }
        ,
        {
          id: "dhv_40_variant1",
          name: "Druckhalteventil DN40 Innere Feder",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 10700,
          qFlex: 10700,
          steigung: 12000,
          steigungMin: 12000,
          durchflussanpassung: 0,
          steigungFlex: 0,
        }
        ,
        {
          id: "dhv_50_variant1",
          name: "Druckhalteventil DN50 Innere Feder",
          hystereseMin: 0.4,
          hysterese: 0.4,
          qMax: 16200,
          qFlex: 16200,
          steigung: 9700,
          steigungMin: 9700,
          durchflussanpassung: 0,
          steigungFlex: 0,
        }

      ]


      var that = this;
      var loadCounter = 0;
      var assetsDir =process.env.NODE_ENV === 'production'
          // ? '../../../../content/dam/gfps/com/website-tools/chemres-tool/js/'
          ? '/content/dam/gfps/com/website-tools/prv-sizing-tool/js/'
          : '';
      function loadHandler()
      {
        var scripts = [
                      "jquery-ui-1.10.4.custom.min.js",
                      "jquery.jqplot.min.js",
                      "jqplot.canvasTextRenderer.min.js",
                      "jqplot.canvasAxisLabelRenderer.min.js",
                      "jqplot.BezierCurveRenderer.min.js",
                      "jqplot.highlighter.min.js",
                      "jqplot.canvasOverlay.min.js"
        ];
        if (loadCounter++ < scripts.length)
        {
          loadScript(assetsDir + scripts[loadCounter-1], loadHandler);
        } else
        {
          $ = window.$;
          that.initSeizingTool();
        }
      }
      loadScript(assetsDir+"jquery-3.5.1.min.js", loadHandler);
    })
  },
  methods: {
    globalreInit: function () {
      window.reInit();
    },
    globalonChangeDiameter: function () {
      window.onChangeDiameter();
    },
    globalonChangeUnit: function () {
      window.onChangeUnit();
    },
    preparePrint: function () {
      window.print();
    },
    sendMail: function () {
      location.href = window.link;
    },
    initSeizingTool: function(){
      var that = this;
      that.$refs.selectvalve.setOptions([{value:"dhv", label:$gettext('Druckhalteventil 586')}, {value:"drv", label:$gettext('Druckreduzierventil 582')}]);
      that.$refs.selectdiamter.setOptions([{value:10,label:$gettext('16DN10 (3/8")')},
                                          {value:15, label:$gettext('20DN15 (1/2")')},
                                          {value:20, label:$gettext('25DN20 (3/4")')},
                                          {value:25, label:$gettext('32DN25 (1")')},
                                          {value:32, label:$gettext('40DN32 (1 ¼")')},
                                          {value:40, label:$gettext('50DN40 (1 ½")')},
                                          {value:50, label:$gettext('63DN50 (2")')}
                                          ]);
      that.$refs.selectpressure_range.setOptions([{value:"variant2", label:$gettext('0.5 - 9 bar')}, {value:"variant1", label:$gettext('0.3 - 3 bar')}]);
      that.$refs.selectunitChange.setOptions([{value:"metric", label:$gettext('Metrisch')}, {value:"us", label:$gettext('Imperial')}]);

      // this.$refs.selectvalve.onChangeSelect(reInit);

  if (getURLParameter("ventilData")!=null) {
    that.$refs.selectvalve.setSelected(getURLParameter("ventilData"));
  }
  if (getURLParameter("inputsDimension")!=null) {
    $('#ventilData').val(getURLParameter("inputsDimension"));
    that.$refs.selectdiamter.setSelected(getURLParameter("inputsDimension"))
  }
  if (getURLParameter("pressure_range")!=null) {
    that.$refs.selectpressure_range.setSelected(getURLParameter("pressure_range"))
  }
  if (getURLParameter("unit")!=null) {
    that.$refs.selectunitChange.setSelected(getURLParameter("unit"))
  }
  if (getURLParameter("pressure")!=null) {
    $('#inletPressure').val(getURLParameter("pressure"))
    $('#outletPressure').val(getURLParameter("pressure"))
  }
  if (getURLParameter("flow")!=null) {
    $('#flowrate').val(getURLParameter("flow"))
  }
      // setTimeout(function () {
      //   window.reInit();
      // }, 2000);

  // var eingangsdruck;

  function hysterese (ventil,ventiltyp,druck,flowrate){

    // var temp; //edit sw
    //
    // if ("dhv"==$('#vc select.valve').val()) {
    //   temp= parseFloat($('#inletPressure').val())
    // } else {
    //   temp= parseFloat($('#outletPressure').val())
    // }

    window.link = "mailto:?subject="+$('#emailValveSubject').val()+"&body="
        +$('#emailValveBody').val()
        +document.URL+"%3F" +
        "pressure_range="+that.$refs.selectpressure_range.val()+
        "%26ventilData="+that.$refs.selectvalve.val()+
        "%26pressure="+$('#inletPressure').val()+
        "%26flow="+$('#flowrate').val()+
        "%26inputsDimension="+$('#ventilData').val()+
        "%26unit="+that.$refs.selectunitChange.val();

    // $('#linkValve').attr('href', link);

    var aufteilungschlieskraft=50
        ,	 koordinatenArray = new Array()
        ,	 ausgangsDruck
        ,	 eingansDruck
        // ,	 ausgangsDruck2
        // ,	 eingansDruck2
        , errechneterDruck
        ,	 durchfluss;
    // DHV Ausgangsdruck muss berechnet werden
    // DVR Eingangsdruck muss gerechnet werden


    if(ventiltyp=="dhv"){
      eingansDruck=druck;
    } else {
      ausgangsDruck=druck;
    }

    if(ventiltyp=="dhv"){
      errechneterDruck=(eingansDruck)-(1/ventil.steigung)*flowrate;
      ausgangsDruck=errechneterDruck;
    } else {
      if(druck<2){
        errechneterDruck=druck + (1/ventil.steigungMin)*flowrate;
      } else {
        errechneterDruck=druck + (1/ventil.steigung)*flowrate;
      }
      eingansDruck=errechneterDruck;
    }
    // console.log("that.$refs.selectunitChange", that.$refs.selectunitChange.val());
    if("metric" == that.$refs.selectunitChange.val()){
      koordinatenArray.push(new Array(0,errechneterDruck));
    }
    else {
      koordinatenArray.push(new Array(Number(0)*0.0037,Number(errechneterDruck)* 14.5037));
    }

    durchfluss= ausgangsDruck<2 ? ventil.qFlex :ventil.qMax;

    if(ventiltyp=="dhv"){
      if(eingansDruck<2){
        errechneterDruck=(1/ventil.steigungMin) *durchfluss +ausgangsDruck;
        if(errechneterDruck<0){
          errechneterDruck=0;
        }
      } else {
        errechneterDruck=(1/ventil.steigung)*durchfluss + ausgangsDruck;
      }
    } else {
      if(ausgangsDruck<2){
        errechneterDruck=(-1/ventil.steigungMin) * durchfluss+eingansDruck;
        if(errechneterDruck<0){
          errechneterDruck=0;
        }
      } else {
        errechneterDruck=(-1/ventil.steigung)*durchfluss+eingansDruck;
      }
    }

    if("metric" == that.$refs.selectunitChange.val()){
      koordinatenArray.push(new Array(durchfluss,errechneterDruck));
    } else {
      koordinatenArray.push(new Array(Number(durchfluss)*0.0037,Number(errechneterDruck)* 14.5037));
    }

    var endwertDruck=errechneterDruck;
    if(ventiltyp=="dhv"){
      if(eingansDruck<2){
        errechneterDruck=endwertDruck+ventil.hysterese;
      } else{
        errechneterDruck=endwertDruck+ventil.hysterese;
      }
    } else {
      if(ausgangsDruck<2){
        errechneterDruck=endwertDruck;
      }
      else{
        errechneterDruck=endwertDruck-ventil.hysterese;
      }
    }

    if("metric" == that.$refs.selectunitChange.val()){
      koordinatenArray.push(new Array(durchfluss,errechneterDruck));
    } else {
      koordinatenArray.push(new Array(Number(durchfluss)*0.0037,Number(errechneterDruck)* 14.5037));

    }
    durchfluss=durchfluss/aufteilungschlieskraft;
    var startDruckGerade1;
    if("metric" == that.$refs.selectunitChange.val()){
      startDruckGerade1=koordinatenArray[0][1];
    } else {
      startDruckGerade1=Number(koordinatenArray[0][1]) * 0.07;
    }
    if(ventiltyp=="dhv"){
      if(eingansDruck<2){
        errechneterDruck=(1/ventil.steigungMin)*durchfluss+startDruckGerade1+ventil.hystereseMin;
      } else {
        errechneterDruck=(1/ventil.steigung)*durchfluss+startDruckGerade1+ventil.hysterese;
      }
    } else {
      if(ausgangsDruck<2){
        errechneterDruck=(-1/ventil.steigungMin)*durchfluss+startDruckGerade1-ventil.hystereseMin;
      } else {
        errechneterDruck=(-1/ventil.steigung)*durchfluss+startDruckGerade1-ventil.hysterese;
      }
    }

    if("metric" == that.$refs.selectunitChange.val()){
      koordinatenArray.push(new Array(durchfluss,errechneterDruck));
    } else {
      koordinatenArray.push(new Array(Number(durchfluss)*0.0037,Number(errechneterDruck)* 14.5037));
    }
    return koordinatenArray;
  }

  function sucheVentil (ventile,suchTitel){
    for ( var i = 0; i < ventile.length; i++ ) {
      var ventil= ventile[i];
      if(ventil.id == suchTitel) {
        return ventil;
      }
    }
  }

  $('.images .sizer').parent('.image').css('position','relative')

  function showPicture(){
    if(that.$refs.selectvalve.val() == 'dhv' ){
      // $('.images img.img').hide()
      // $('.images img.dhv').fadeIn();
      $("#productImg").hide();
      $("#productImg2").css("display", "inline");
      $('#blockInletPressure').show();
      $('#blockOutletPressure').hide();
    } else {
      // $('.images img.img').hide()
      // $('.images img.drv').fadeIn();
      $("#productImg").css("display", "inline");
      $("#productImg2").hide();
      $('#blockInletPressure').hide();
      $('#blockOutletPressure').show();
    }
  }

  // $('.valve').change(function() {
  //   that.showPicture();
  // });

  showPicture();

  $('.toggle').click(function(){
    var $t = $(this);
    $t.toggleClass('closed')
    if($t.hasClass('closed')){
      $t.prevAll('.row').fadeOut()
    } else {
      $t.prevAll('.row').fadeIn()
    }
  });

  $('div.tooltip').click(function(){
    var $t = $(this)
    if($t.hasClass('active')){
      $t.find('.inner').fadeOut('',function(){
        $t.removeClass('active')
      })
    } else {
      $('div.tooltip').removeClass('active').find('.inner').hide()
      $t.addClass('active').find('.inner').fadeIn()
    }
  });

  $('.form_button_submit').click(function(e){
    e.preventDefault()
    reInit()
  });

      var $title, $plot;

      var renderGraph = function() {

        var $searchString= ""
            // console.log("$inputsValve", that.$refs.selectvalve.val());
        // var $inputsValve =$('select.valve').val()

        var $inputsValve =that.$refs.selectvalve.val();


        var $inputsDimension= $('#ventilData').val()
        /* check */

        var $inputsRange= that.$refs.selectpressure_range.val()
// console.log("that.$refs.selectpressure_range.val()", that.$refs.selectpressure_range.val());
        var $pressure;
        "dhv" == that.$refs.selectvalve.val() ? $pressure=parseFloat($('#inletPressure').val()) : $pressure=parseFloat($('#outletPressure').val());

        var $flowrate= parseFloat($('#flowrate').val())


        $searchString+=$inputsValve+"_"+$inputsDimension+"_"+$inputsRange;

        var $sprachDatei = ventilDaten;

        if("metric" != that.$refs.selectunitChange.val()){
          $pressure = $pressure * 0.07
          $flowrate = $flowrate * 272.76
          $pressure.toFixed(2)
          $flowrate.toFixed(2)
        }
        // console.log("=========== rendergraph ============");
// console.log("$sprachDatei",$sprachDatei);
// console.log("$searchString",$searchString);
// console.log(sucheVentil($sprachDatei,$searchString));
//         console.log("that.$refs.selectunitChange.val()", that.$refs.selectunitChange.val());
        var $cord = hysterese(sucheVentil($sprachDatei,$searchString), $inputsValve ,parseFloat($pressure),$flowrate)
// console.log("$cord", $cord);
        $.jqplot.postDrawHooks.push(function() {
          $(".jqplot-overlayCanvas-canvas").css('z-index', '0'); //send overlay canvas to back
          $(".jqplot-series-canvas").css('z-index', '1'); //send series canvas to front
          $(".jqplot-highlighter-tooltip").css('z-index', '2'); //make sure the tooltip is over the series
          $(".jqplot-event-canvas").css('z-index', '5'); //must be on the very top since it is responsible for event catching and propagation
        });

        var xaxisFormatString;
        var yaxisLabel;
        var xaxisLabel;
        var yaxisMax;
        if("metric" != that.$refs.selectunitChange.val()){
          $pressure = $pressure * 14.5037
          $flowrate = $flowrate * 0.0037
          $pressure.toFixed(2)
          $flowrate.toFixed(2)
          yaxisLabel="psi";
          xaxisLabel="gpm";
          yaxisMax=140;
          xaxisFormatString='%.1f ';

        } else {
          yaxisLabel="bar";
          yaxisMax=10;
          xaxisLabel="l/h";
          xaxisFormatString='%.0f ';
        }

        var $flowrate2=parseFloat($flowrate)+parseFloat(0.000002);

        var $hysterese = [
          [ $cord[0], $cord[1] ],
          [ $cord[1], $cord[2] ],
          [ $cord[2], $cord[3] ],
          [ $cord[3],[(($cord[3][0]+$cord[0][0])/2)-8,(($cord[3][1]+$cord[0][1])/2)],$cord[0] ],
          [[$flowrate,$pressure],[$flowrate2,$pressure] ]
        ]
        setPlotTitle()

            // eslint-disable-next-line no-unused-vars
        $plot = $.jqplot('canvas', $hysterese , {
          title: $title,
          axes: {
            yaxis: {
              min: 0,
              max: yaxisMax,

              tickOptions: {
                formatString: '%.0f '
              },
              numberTicks: 11,
              label: yaxisLabel,
              labelRenderer: $.jqplot.CanvasAxisLabelRenderer
            },
            xaxis: {
              min: 0,
              max: $cord[2][0],
              tickOptions: {
                formatString: xaxisFormatString
              },
              label: xaxisLabel,
              labelRenderer: $.jqplot.CanvasAxisLabelRenderer
            }
          },
          canvasOverlay: {
            show: true,
            objects: [
              {
                rectangle: {
                  xmin: 0,
                  xmax: ($cord[2][0]*0.1),
                  xminOffset: "0px",
                  xmaxOffset: "0px",
                  yminOffset: "0px",
                  ymaxOffset: "0px",
                  color: "rgba(255, 204, 0, 0.75)",
                  showTooltip: true,
                  tooltipFormatString: $('#vibration').val(),
                  tooltipLocation: 'e',
                }
              },
              {
                rectangle: {
                  xmin: ($cord[2][0]*0.1),
                  xmax: $cord[2][0],
                  xminOffset: "0px",
                  xmaxOffset: "0px",
                  yminOffset: "0px",
                  ymaxOffset: "0px",
                  color: "rgba(102, 194, 102, 0.75)",
                  showTooltip: true,
                  tooltipFormatString: $('#optimum').val(),
                  tooltipLocation: 'e',
                }
              }
            ]
          },
          highlighter: {
            show: true
          },
          seriesDefaults: {
            color: '#4F4F4F',
            showMarker: false,
            shadow: false
          },
          series:[
            {  },
            {  },
            {  },
            {
              rendererOptions: { smooth: true }
            },
            {
              color: '#4169E1',
              style: 'filledCircle',
              lineWidth: 7,
              showMarker: true,
              shadow: true
            }
          ],
        });
      },
      resizeGraph = function() {
        reInit()
      },
      setPlotTitle = function(){
        // $title = $('#hysteresisname').val()+' ' + $('#ventilData :selected').text()
        $title = $('#hysteresisname').val()+' ' + that.$refs.selectdiamter.label()
      };

  // $('.diameter').change(function(){
    function onChangeDiameter()
    {
      // console.log("that.$refs.selectdiamter.index()", that.$refs.selectdiamter.index());

    var tmp = that.$refs.selectdiamter.index();
    $('#ventilData option').eq(tmp).attr('selected', 'selected');

    reInit();
  }
  window.onChangeDiameter = onChangeDiameter;
  $('#ventilData, .pressure_range').change(function(){
    reInit();
  })

      // sw end of edit!!

  // $('select#unitChange').change(function(){
function onChangeUnit()
{
    if("metric" == that.$refs.selectunitChange.val()){
      var bar_psi = parseFloat($('#inletPressure').val())
      bar_psi = bar_psi * 0.07
      $('#inletPressure').val(bar_psi.toFixed(2))
      bar_psi = parseFloat($('#outletPressure').val())
      bar_psi = bar_psi * 0.07
      $('#outletPressure').val(bar_psi.toFixed(2))

      var lh_gpm =  parseFloat($('#flowrate').val())
      lh_gpm = lh_gpm * 272.76
      $('#flowrate').val(lh_gpm.toFixed(2))

    } else {

      var psi_bar = parseFloat($('#inletPressure').val())
      psi_bar = psi_bar * 14.5037
      $('#inletPressure').val(psi_bar.toFixed(2))

      psi_bar = parseFloat($('#outletPressure').val())
      psi_bar = psi_bar * 14.5037
      $('#outletPressure').val(psi_bar.toFixed(2))

      var gpm_lh =  parseFloat($('#flowrate').val())
      gpm_lh = gpm_lh * 0.0037
      $('#flowrate').val(gpm_lh.toFixed(3))

    }

    if("metric" == that.$refs.selectunitChange.val()){
      $('span.unit_1').html(unit1_de)
      $('span.unit_2').html(unit2_de)

      // $('select.diameter option').each(function() {
      //   switch (parseInt($(this).val())) {
      //     case 10:
      //       $(this).html('16DN10 (3/8")')
      //       break;
      //     case 15:
      //       $(this).html('20DN15 (1/2")')
      //       break;
      //     case 20:
      //       $(this).html('25DN20 (3/4")')
      //       break;
      //     case 25:
      //       $(this).html('32DN25 (1")')
      //       break;
      //     case 32:
      //       $(this).html('40DN32 (1 ¼")')
      //       break;
      //     case 40:
      //       $(this).html('50DN40 (1 ½")')
      //       break;
      //     case 50:
      //       $(this).html('63DN50 (2")')
      //       break;
      //     default:
      //       break;
      //   }
      // });

      // that.$refs.selectdiamter.setOptions([{value:10, label:'16DN10 (3/8")'},
      //   {value:15, label:'20DN15 (1/2")'},
      //   {value:20, label:'25DN20 (3/4")'},
      //   {value:25, label:'32DN25 (1")'},
      //   {value:32, label:'40DN32 (1 ¼")'},
      //   {value:40, label:'50DN40 (1 ½")'},
      //   {value:50, label:'63DN50 (2")'}
      // ]);

      $('#ventilData option').each(function() {
        switch (parseInt($(this).val())) {
          case 10:
            $(this).html('16DN10 (3/8")')
            break;
          case 15:
            $(this).html('20DN15 (1/2")')
            break;
          case 20:
            $(this).html('25DN20 (3/4")')
            break;
          case 25:
            $(this).html('32DN25 (1")')
            break;
          case 32:
            $(this).html('40DN32 (1 ¼")')
            break;
          case 40:
            $(this).html('50DN40 (1 ½")')
            break;
          case 50:
            $(this).html('63DN50 (2")')
            break;
          default:
            break;
        }
      });

      // $('select.pressure_range option').each(function(){
      //   if("variant1"==$(this).val()){
      //     $(this).html('0,3 - 3 bar')
      //   } else {
      //     $(this).html('0,5 - 9 bar')
      //   }
      // });
      that.$refs.selectpressure_range.setOptions([{value:"variant2", label:$gettext('0.5 - 9 bar')}, {value:"variant1", label:$gettext('0.3 - 3 bar')}]);
      that.$refs.selectpressure_range.setSelected("variant2");
    } else {
      $('span.unit_1').html(unit1_en)
      $('span.unit_2').html(unit2_en)

      // $('select.diameter option').each(function(){
      //   switch (parseInt($(this).val())) {
      //     case 10:
      //       $(this).html('16DN10 (3/8")')
      //       break;
      //     case 15:
      //       $(this).html('20DN15 (1/2")')
      //       break;
      //     case 20:
      //       $(this).html('25DN20 (3/4")')
      //       break;
      //     case 25:
      //       $(this).html('32DN25 (1")')
      //       break;
      //     case 32:
      //       $(this).html('40DN32 (1 ¼")')
      //       break;
      //     case 40:
      //       $(this).html('50DN40 (1 ½")')
      //       break;
      //     case 50:
      //       $(this).html('63DN50 (2")')
      //       break;
      //     default:
      //       break;
      //   }
      // });

      // that.$refs.selectdiamter.setOptions([{value:10, label:'16DN10 (3/8")'},
      //   {value:15, label:'20DN15 (1/2")'},
      //   {value:20, label:'25DN20 (3/4")'},
      //   {value:25, label:'32DN25 (1")'},
      //   {value:32, label:'40DN32 (1 ¼")'},
      //   {value:40, label:'50DN40 (1 ½")'},
      //   {value:50, label:'63DN50 (2")'}
      // ]);

      $('#ventilData option').each(function() {
        switch (parseInt($(this).val())) {
          case 10:
            $(this).html('16DN10 (3/8")')
            break;
          case 15:
            $(this).html('20DN15 (1/2")')
            break;
          case 20:
            $(this).html('25DN20 (3/4")')
            break;
          case 25:
            $(this).html('32DN25 (1")')
            break;
          case 32:
            $(this).html('40DN32 (1 ¼")')
            break;
          case 40:
            $(this).html('50DN40 (1 ½")')
            break;
          case 50:
            $(this).html('63DN50 (2")')
            break;
          default:
            break;
        }
      });

      // $('select.pressure_range option').each(function(){
      //   if ("variant1"==$(this).val()) {
      //     $(this).html('4 - 44 psi')
      //   } else {
      //     $(this).html('7 - 130 psi')
      //   }
      // });

      that.$refs.selectpressure_range.setOptions([{value:"variant2", label:$gettext('4 - 44 psi')}, {value:"variant1", label:$gettext('7 - 130 psi')}]);
      that.$refs.selectpressure_range.setSelected("variant2");

    }

    // eslint-disable-next-line no-unused-vars
    var temp;

    if ("dhv"==that.$refs.selectvalve.val()) {
      temp= parseFloat($('#inletPressure').val())
    } else {
      temp= parseFloat($('#outletPressure').val())
    }
  reInit();
  }// end changeUnit
    window.onChangeUnit = onChangeUnit;
  function reInit() {
    // console.log("## reInit" );
    setPlotTitle();
    if ($plot)
      $plot.destroy();
    renderGraph();
    showPicture();
  }
  window.reInit = reInit;
  renderGraph();
  reInit();

  if (getURLParameter("unit")!=null&&getURLParameter("unit")=="us") {
    $('#unitChange').val(getURLParameter("unit"))

    $('select.pressure_range option').each(function(){
      if ("variant1"==$(this).val()) {
        $(this).html('4 - 44 psi')
      } else {
        $(this).html('7 - 130 psi')
      }
    });

    $('span.unit_1').html(unit1_en)
    $('span.unit_2').html(unit2_en)

    reInit();
  }

  $(window).resize(function() {
    resizeGraph();
  });



  $('#flowrate').change(function() {
    $('#flowrate').val(parseFloat(new String($('#flowrate').val()).replace(",",".")));
    reInit();
  });

  $('#inletPressure').change(function() {


    $('#inletPressure').val(parseFloat(new String($('#inletPressure').val()).replace(",",".")));
    reInit();
  });

  $('select.valve').change(function() {
    reInit();
  });

  $('#outletPressure').change(function() {
    $('#outletPressure').val(parseFloat(new String($('#outletPressure').val()).replace(",",".")));
    reInit();
  });

  $('#unitChange').change(function() {
    reInit();
  });
}
  }
}
</script>

<style scoped>
@font-face {
  font-family: "DINNextLTW05-Regular";
  src: url("../assets/DINNextLTW05-Regular.eot?#iefix");
  src: url("../assets/DINNextLTW05-Regular.eot?#iefix") format("eot"),
  url("../assets/DINNextLTW05-Regular.woff2") format("woff2"),
  url("../assets/DINNextLTW05-Regular.woff") format("woff"),
  url("../assets/DINNextLTW05-Regular.ttf") format("truetype");
}

@font-face {
  font-family: "GlyphaLTW05-65Bold";
  src: url("../assets/GlyphaLTW05-65Bold.eot?#iefix");
  src: url("../assets/GlyphaLTW05-65Bold.eot?#iefix") format("eot"),
  url("../assets/GlyphaLTW05-65Bold.woff2") format("woff2"),
  url("../assets/GlyphaLTW05-65Bold.woff") format("woff"),
  url("../assets/GlyphaLTW05-65Bold.ttf") format("truetype");
}

@font-face {
  font-family: "DINNextLTW01-Medium";
  src: url("../assets/DINNextLTW01-Medium.eot?#iefix");
  src: url("../assets/DINNextLTW01-Medium.eot?#iefix") format("eot"),
  url("../assets/DINNextLTW01-Medium.woff2") format("woff2"),
  url("../assets/DINNextLTW01-Medium.woff") format("woff"),
  url("../assets/DINNextLTW01-Medium.ttf") format("truetype");
}
#prv-sizing-tool {

}
#toolInputs, #vc {
  width: 90vw;
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;
  border: 1px solid #bbb;
  padding: 20px;
  font-family: "DINNextLTW05-Regular", Arial, sans-serif;
}
#vc {
  border-top:0;
  padding-top:46px
}
h2 {
  font-family: "DINNextLTW05-Regular", Arial, sans-serif;
  color: #0065A7;
  margin-top: 0;
}
select,
input {
  -webkit-font-smoothing: antialiased;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  background-color: #f0f0f0;
  border: 0.1875rem solid #f0f0f0;
  border-radius: 0;
  display: block;
  font-family: DINNextLTW05-Regular, sans-serif;
  font-size: 1.125rem;
  /* font-size: 12px; */
  height: 2.5rem;
  padding: 0.3125rem 2.375rem 0.3125rem calc(0.1875rem + 0.3125rem);
  width: 100%;
  outline: none;
}
select:focus {
  background-color: #fff;
  border-color: #f0f0f0;
}
select option {
  font-family: "DINNextLTW05-Regular", sans-serif;
}
.selectWrapper, .inputWrapper {
  color: #000;
  font-family: "DINNextLTW05-Regular", sans-serif;
  font-size: 16px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  flex-basis: 100%;
  margin-top: 8px;
  position: relative;
}

.selectWrapper::after {
  content: "";
  display: block;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 7.6l-6-6L1.6 0 6 4.4 10.4 0 12 1.6l-6 6z' fill='%2333ADFF' fill-rule='evenodd'/%3E%3C/svg%3E");
  background-position: center;
  background-size: 0.75rem 0.5rem;
  background-repeat: no-repeat;
  height: 2.5rem;
  pointer-events: none;
  position: absolute;
  right: 1rem;
  top: 0;
  width: 0.75rem;
}
.halfRow {
  width: 32%;
  display: inline;
  float: left;
  margin-right:1.5%;
}
.myblock {
  display: inline;
  float: left;
  width: 99%;
  margin-top:10px;
}
.myLabel {
  font-size: 16px;
  text-align: left;
}
.infoI {
  background: url(../assets/infoI.png) no-repeat;
  bottom: 1px;
  height: 20px;
  width: 20px;
  cursor: pointer;
  z-index: 1000;
  vertical-align: sub;
  float: right;
  margin-top: 0px;
}
.clearfix {
  clear: both;
}
.imageWrapper {
  border: 1px solid #bbb;
  /*height: 295px;*/
  height: 314px;
  /*margin-top: 27px;*/
  margin-top: 33px;
  text-align: center;
}
.helper {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
#sendEmail:before {
  content: url("../assets/email.png");
  margin-right: 8px;
  vertical-align: middle;
}
#sendEmail {
  color: #00abfe;
  font-size: 16px;
  cursor: pointer;
  font-family: "DINNextLTW01-Medium", Arial;
}
#doPrint {
  color: #00abfe;
  font-size: 16px;
  cursor: pointer;
  margin-right: 35px;
  margin-left: 8px;
  font-family: "DINNextLTW01-Medium", Arial;
}
#doPrint:before {
  content: url("../assets/print.png");
  margin-right: 8px;
  vertical-align: middle;
}
.arrow {
  float: left;
  margin-top: 18px;
}
.halfRow h2 {
  font-size: 20px;
  color: #000000;
}
@media screen and (max-width:670px) {
  .main {
    width:92%;
    margin: 0;
    /*padding:2px;*/
  }
  .halfRow {
    width:99%;
  }
  .row3 {
    width: 100%;
  }
  #toolInputs, #vc {
    width: unset;
  }
  .performancedata {
    margin-top:20px;
  }
}
@media print {
  * {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }
  #toolInputs, #vc {
    width: 100%;
    border: 0;
  }
  #toolInputs {
    width:95%;
  }
  .hidePrint {
    display:none;
  }

  #canvas {
    width: 89% !important;
  }
  #vc,.inputz {
    width:90%;
    margin-right: 0;
    margin-left:0;
  }

}
</style>
<style>
@media print {
  html {
    overflow: unset !important;
  }
  ._text ._text--default, #text {
    display:none !important;
  }
}
.multiselect__option--highlight {
  background: #f0f0f0 !important;
  outline: none;
  color: #000;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: #f0f0f0 !important;
  color: #000;
}
.multiselect__single {
 background-color: #f0f0f0 !important;
}
.jqplot-yaxis-label {
  font-size: 11pt;
  position: absolute;
  left: -16px !important;
}
.jqplot-title {
  font-family: "DINNextLTW05-Regular", Arial, sans-serif;
  color: #0065A7;
  text-align: left !important;
  font-size: 24px;
  font-weight: 700;
  top: -27px !important;
}
.myTooltip {
  background-color: #fff;
  border: 1px solid #999;
  color: #000;
  font-family: DINNextLTW05-Regular;
}

.tooltip-arrow {
  display: none !important;
  border-color: red;
}
.jqplot-title {
  font-size: 20px;
  color: #000000;
}
</style>